//#region src/bite_admin_mfa_option.ts
let BiteAdminMfaOption = /* @__PURE__ */ function(BiteAdminMfaOption) {
	BiteAdminMfaOption["Email"] = "email";
	return BiteAdminMfaOption;
}({});
//#endregion
export { BiteAdminMfaOption };

//# sourceMappingURL=bite_admin_mfa_option.js.map